// Product images must always be requested at a 3:2 ratio (e.g. 192x128) so the
// CDN crop matches the aspect ratio used app-wide in product image markup.
const PRODUCT_IMAGE_RATIO = 3 / 2;

// Old mobile hardware still needs sharp images on retina screens, so every
// request is made at 2x the CSS pixel width the image is actually displayed at.
const RETINA_SCALE = 2;

/** Empty in, empty out - callers use the result's truthiness to skip the image. */
export const productImageUrl = (url: string, displayWidth: number): string => {
  if (!url) {
    return '';
  }

  const width = Math.round(displayWidth * RETINA_SCALE);
  const height = Math.round(width / PRODUCT_IMAGE_RATIO);
  return `${url}/${width}x${height}`;
};
